import { useEffect } from 'react';
import Loader from '../../components/loader';
import useAuth from '../../hooks/auth/useAuth';

function AuthCheck() {
    const { checkAuth } = useAuth();

    useEffect(() => {
        checkAuth();
    }, []);

    return (
        <Loader loading title="Проверка авторизации" />
    );
}

export default AuthCheck;
